import { useIsIntelligems } from "@src/api/user-auths/is-intelligems";
import { useLoggedInUser } from "@src/api/user-auths/login";
import { useAdminHasFullAccess } from "@src/api/user-auths/use-admin-has-full-access";

export const useIsAdmin = () => {
  const isIntelligems = useIsIntelligems();
  const adminHasFullAccess = useAdminHasFullAccess();
  const user = useLoggedInUser();
  const isLoading = isIntelligems === undefined || user.isLoading;

  if (isLoading) {
    return undefined;
  }

  if (!isIntelligems) {
    return false;
  }

  if (user.data?.user?.email === "member@intelligems.io") {
    return false;
  }

  return adminHasFullAccess;
};
